var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"47.5px !important","height":"45px !important"},attrs:{"src":require("@/assets/images/logo/csm_logo.png"),"alt":"logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }